import { CircularProgress } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import React from 'react';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const styles = theme => ({
  focused: {
    borderBottom: '2px solid white',
  },
  underline: {
    borderBottom: '2px solid white',
  },
  root: { color: 'black !important' },
  helpTxt: { color: 'red !important' },
});

class LoginForm extends React.Component {
  state = {};
  trimOnBlur = (handleBlur, setFieldValue) => e => {
    handleBlur(e);
    let trimedString = e.currentTarget.value.trim();
    setFieldValue('email', trimedString);
  };
  componentDidMount() {
    this.props.validateForm();
  }
  render() {
    const {
      handleSubmit,
      values,
      errors,
      touched,
      handleBlur,
      handleChange,
      isSubmitting,
      showPassword,
      handleClickShowPassword,
      handleMouseDownPassword,
      location,
      waiting,
      classes,
      setFieldValue,
    } = this.props;
    return (
      <div id="loginRegistrationForm">
        <form data-testid="submit" onSubmit={handleSubmit}>
          {location.pathname !== '/login' ? null : (
            <React.Fragment>
              <FormControl fullWidth className="u-mrg-top-20">
                <InputLabel
                  htmlFor="email"
                  classes={{
                    root: 'label--c-gray',
                  }}
                >
                  Email {location.pathname !== '/login' ? null : '/ Username'}
                </InputLabel>
                <Input
                  classes={{
                    underline: 'underline--c-black',
                  }}
                  autoFocus
                  id="email"
                  type="text"
                  name="email"
                  label="Email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={this.trimOnBlur(handleBlur, setFieldValue)}
                />
              </FormControl>
              <FormControl fullWidth className="u-mrg-top-20">
                <InputLabel
                  htmlFor="password"
                  classes={{
                    root: 'label--c-gray',
                  }}
                >
                  Password
                </InputLabel>
                <Input
                  classes={{
                    underline: 'underline--c-black',
                  }}
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  label="Password"
                  name="password"
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
              <Button
                data-testid="button"
                variant="contained"
                color="primary"
                fullWidth
                type="submit"
                disabled={
                  isSubmitting || errors.email || errors.password ? true : false
                }
                className="u-mrg-top-50 t-weight-b"
              >
                {isSubmitting
                  ? 'Checking credentials...'
                  : location.pathname === '/login'
                  ? 'Login'
                  : 'Sign Up'}
                {isSubmitting && (
                  <CircularProgress
                    className="u-mrg-left-10"
                    size={18}
                    color="inherit"
                  />
                )}
              </Button>
            </React.Fragment>
          )}
          {location.pathname === '/registration' ? (
            <React.Fragment>
              <FormControl fullWidth className="u-mrg-top-20">
                <TextField
                  // autoFocus
                  id="email"
                  type="text"
                  name="email"
                  label="Email"
                  value={values.email}
                  onChange={handleChange}
                  margin="normal"
                  helperText={errors.email}
                  InputLabelProps={{
                    classes: {
                      formControl: classes.root,
                    },
                  }}
                  InputProps={{
                    classes: {
                      focused: classes.focused,
                      underline: 'underline--c-black',
                    },
                  }}
                  FormHelperTextProps={{
                    classes: {
                      root: classes.helpTxt,
                    },
                  }}
                  onFocus={this.showMessage}
                />
              </FormControl>

              <h5 style={{ color: 'red' }}>
              Note: this form is for use by luminaire manufacturers/suppliers only. Lighting Designer and Specifier users, please email info@luminairebroker.com for more information and to request an invitation to register.</h5>
              <Button
                disabled={
                  (touched.email && errors.email) || waiting ? true : false
                }
                data-testid="button"
                variant="contained"
                color="primary"
                fullWidth
                type="submit"
                className="u-mrg-top-10 t-weight-b"
              >
                {waiting ? 'Wait...' : 'Request invitation'}
                {waiting && (
                  <CircularProgress
                    className="u-mrg-left-10"
                    size={18}
                    color="inherit"
                  />
                )}
              </Button>
            </React.Fragment>
          ) : null}
          {/* {touched.email && errors.email ? trigerUpdateMessage(errors.email) : null} */}
        </form>
      </div>
    );
  }
}
LoginForm.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(LoginForm);
